
export const CgnPasswordControl = new RegExp(
    /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?).{6,}$/ // six characters, at least one uppercase letter, one lowercase letter, one number...
  );